// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g5D14","comment":"styles_comment__3Z5D-"};